import { formatVideoUrl } from 'components/utils';
import { renderImage, renderParagraph } from 'components/utils/render'
import React, { useState } from 'react'
import { ColumnComponent } from '../MultiColumn.models'
import { StandAloneImageContainer, ImageContainer, Picture, Play, Video, VideoContainer, ParagraphContainer, ButtonContainer, TallyContainer, ImageCaption } from './DynamicComponent.style';
import PlayFillIcon from 'remixicon-react/PlayFillIcon';
import { Button, Tally } from 'components/common';


export const DynamicComponent = (component: ColumnComponent) => {
  const { type } = component;
  const [playVideo, setPlayVideo] = useState(false);
  
  const getComponent = (): React.ReactNode => {
    const componentData = component as any;
    let isIconButton = ['external', 'download', 'link', 'arrow', 'secondaryArrow'].indexOf(componentData?.btnType) >= 0;
    console.log(componentData);
    switch (type) {
      case 'RichTextBlock':
        return (
            <ParagraphContainer>
              {renderParagraph(componentData.richTextBlock)}
            </ParagraphContainer>
        );
      case 'button':
        return (
          <ButtonContainer isIconButton={isIconButton}>
            <Button isDynamicBtn {...componentData}/>
          </ButtonContainer>
            );
      case 'donationTally':
        return <TallyContainer>
                  <Tally {...componentData} />
                </TallyContainer> 
      case 'image':
        return  component.hasImageOnly ?
          <StandAloneImageContainer>
            {renderImage(componentData)}
           </StandAloneImageContainer>
           :
           <>
            <ImageContainer data-attribute='imageContainer' hasHeading={component.hasHeading}>
                <Picture hasHeading={component.hasHeading}>
                  {renderImage(componentData)}
                </Picture> 
            </ImageContainer>
            {componentData.caption && <ImageCaption data-attribute='imageCaption'>{componentData.caption}</ImageCaption>}
           </>
            
        ;
      case 'video':
        return (
              <Video onClick={() => setPlayVideo(!playVideo)}>
                  {
                      playVideo ?
                      <VideoContainer src={formatVideoUrl(componentData.videoURL)} allow='autoplay'/> :
                      <>
                          {renderImage(componentData)}
                          <Play>
                            <PlayFillIcon />
                          </Play>
                      </>
                  }
              </Video> 
        );
      default:
        return <></>;
    }
  }

  return (
    <React.Fragment>
      {getComponent()}
    </React.Fragment>
  )
}